module.exports = __webpack_public_path__ + "static/img/IMG_20150307_171131.db94e1c0.jpg";